import { SectionCard } from '@/components/common/SectionCard';
import { Button } from '@/components/ui/Button';
import { CREATE_STARTUP_STRINGS, SECTION_TITLES } from '../constants';

interface SaveProfileCardProps {
  isSaving: boolean;
}

/** Step 4 "Ready to Save Your Profile?" card (Figma 198:598) - plain confirm-and-save, no OTP step. */
export function SaveProfileCard({ isSaving }: SaveProfileCardProps) {
  return (
    <SectionCard className="text-center">
      <h2 className="font-sans text-h5 text-navy">{SECTION_TITLES.SAVE_CARD}</h2>
      <p className="mx-auto mt-2 max-w-xl text-sm text-subtext">
        {CREATE_STARTUP_STRINGS.SAVE_CARD_INTRO}
      </p>
      <div className="mx-auto mt-5 max-w-2xl">
        <Button type="submit" variant="primary" className="w-full text-base" disabled={isSaving}>
          {isSaving ? CREATE_STARTUP_STRINGS.SAVING : CREATE_STARTUP_STRINGS.SAVE}
        </Button>
      </div>
    </SectionCard>
  );
}
